module.exports = __webpack_public_path__ + "img/coupon_bg.65a10933.png";